import _defineProperty from "C:\\Users\\ADIAZ\\Documents\\4GFLOTANEW\\Erpv2.0\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import _objectWithoutProperties from "C:\\Users\\ADIAZ\\Documents\\4GFLOTANEW\\Erpv2.0\\node_modules\\@babel\\runtime\\helpers\\esm\\objectWithoutProperties.js";
var _excluded = ["bsPrefix", "className", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var Row = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = _objectWithoutProperties(_ref, _excluded);

  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'row');
  var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;

    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-".concat(brkPoint) : '';
    if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
  });
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: classNames.apply(void 0, [className, decoratedBsPrefix].concat(classes))
  }));
});
Row.displayName = 'Row';
export default Row;